/* __next_internal_client_entry_do_not_use__ RenderRetailerSignUp auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSettingLazyLoadSignupRoutes } from "@faire/retailer-visitor-shared/settings/useSettingLazyLoadSignupRoutes";
import { LazySignUpRootWithLazyRoutes } from "@faire/retailer-visitor-shared/views/SignUp/_lazy-route-wrappers/LazySignUpRootWithLazyRoutes";
import { LazySignUpRootWithRoutes } from "@faire/retailer-visitor-shared/views/SignUp/_lazy-route-wrappers/LazySignUpRootWithRoutes";
import { Route } from "@faire/web-api--source/Route";
import { props as signUpRouteProps } from "@faire/web-api--source/routes/welcome/r";
import React from "react";
export var RenderRetailerSignUp = function() {
    var shouldShowLazyLoadedRoutes = useSettingLazyLoadSignupRoutes();
    return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, signUpRouteProps), {
        render: function() {
            if (shouldShowLazyLoadedRoutes) {
                return /*#__PURE__*/ _jsx(LazySignUpRootWithLazyRoutes, {});
            }
            return /*#__PURE__*/ _jsx(LazySignUpRootWithRoutes, {});
        }
    }));
};
